import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: 0;
  height: 100%;
`;

export const Title = styled.h1`
  color: #181818;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;

export const ContentScroller = styled.div`
  min-height: 0;
  flex: 1 1 auto;
  overflow: auto;
  padding-right: 16px;

  @media (max-width: 1080px) {
    overflow: visible;
    padding-right: 0;
  }
`;

export const RowIcon = styled.span.attrs({ className: "row-action-icon" })`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  color: #7c7f7e;
  transition: color 0.2s ease;

  & i {
    font-size: 12px;
  }
`;

export const FlowsheetIdCell = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 28px;
  min-width: 0;
`;

export const TableScroller = styled.div`
  max-width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  padding-bottom: 10px;
`;

export const FlowsheetTable = styled.table`
  width: max-content;
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  color: #181818;
  font-size: 14px;
  line-height: 20px;

  & th,
  & td {
    border-bottom: 1px solid #e7e7e7;
    padding: 12px 14px;
    text-align: left;
    white-space: nowrap;
  }

  & th {
    font-weight: 600;
  }

  & tbody tr:hover th,
  & tbody tr:hover td {
    background: #e7e7e7;
  }

  & thead th:first-child,
  & tbody th {
    position: sticky;
    left: 0;
    background: #ffffff;
  }

  & thead th:first-child {
    z-index: 3;
    width: 287px;
    min-width: 287px;
  }

  & tbody th {
    z-index: 2;
    width: 287px;
    min-width: 287px;
    max-width: 287px;
    font-weight: 500;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: normal;
  }

  & tbody tr:hover th {
    background: #e7e7e7;
  }
`;
